import { ITireItemDetail } from "features/car_model/types";
import { postInventorySearchApi } from "features/mst_proc_fee/api/procFeeApi";

interface InventoryItem {
  item_code?: string;
  item_cd?: string;
  store_quantity?: number;
  vendor_centor_quantity?: number;
  depot_quantity?: number;
}

/**
 * Fetch inventory data and map to tire list
 * @param tireItems - List of tire items from API response
 * @param currentTireList - Current tire list to update
 * @returns Updated tire list with inventory data
 */
export async function fetchAndMapInventory(
  tireItems: ITireItemDetail[],
  currentTireList: ITireItemDetail[],
): Promise<ITireItemDetail[]> {
  try {
    if (!tireItems || tireItems.length === 0) return currentTireList;

    // Get client_cd (shop_cd) from localStorage
    const shopCd = localStorage.getItem("shop_cd") || "";
    if (!shopCd) return currentTireList;

    // Extract all item_cds from tire items as array
    const itemCdArray = tireItems.map((item) => item.item_cd);

    // Call postInventorySearchApi
    const inventoryResponse = await postInventorySearchApi({
      set_flag: 0,
      client_cd: shopCd,
      item_cds: itemCdArray,
    });

    // Map inventory data to tire list
    const inventoryList = Array.isArray(inventoryResponse)
      ? inventoryResponse
      : Array.isArray(inventoryResponse?.list)
        ? inventoryResponse.list
        : null;

    if (inventoryList && inventoryList.length > 0) {
      const inventoryMap = new Map<string, InventoryItem>(
        inventoryList.map((inv: InventoryItem) => [inv.item_code ?? inv.item_cd ?? "", inv]),
      );

      const result = currentTireList.map((tire) => {
        const inventoryItem = inventoryMap.get(tire.item_cd);

        if (inventoryItem) {
          return {
            ...tire,
            store_quantity: inventoryItem.store_quantity ?? tire.store_quantity,
            vendor_centor_quantity:
              inventoryItem.vendor_centor_quantity ?? tire.vendor_centor_quantity,
            depot_quantity: inventoryItem.depot_quantity ?? tire.depot_quantity,
          };
        }

        return tire;
      });

      return result;
    }

    return currentTireList;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to fetch inventory:", error);
    return currentTireList;
  }
}

export default fetchAndMapInventory;
